import React, { useCallback, useMemo } from 'react';
import { ReactComponent as ChevronLeftIcon } from 'assets/svg/2_arrow_left.svg';
import { ReactComponent as ChevronRightIcon } from 'assets/svg/2_arrow_right.svg';
import styles from 'css_modules/Pagination.module.css';
import { NavSelect } from './NavSelect';

export const ItemsPagination = ({
    user,
    currentPage,
    lastPage,
    setPage,
    limit,
    setLimit,
    items
}) => {

    const setTouched = () => {
        localStorage.setItem("formTouched", "false");
    };

    const goTo = useCallback(
        (page) => () => {
            setTouched();
            setPage(page);
        },
        [setPage]
    );

    const limits = useMemo(
        () => [10, 20, 30, 40, 50, 100, 200].map(v => ({ id: v, title: v })),
        []
    );

    const changeLimit = useCallback(
        (e) => {
            const value = Number(e.target.value);
            setTouched();
            localStorage.setItem(`limitItems${user.pk}`, value);
            setLimit(value);
            setPage(1);
        },
        [setLimit, setPage, user.pk]
    );

    const pageWindow = useMemo(() => {
        const windowSize = 5;
        const half = Math.floor(windowSize / 2);

        let start = currentPage - half;
        let end = currentPage + half;

        if (start < 1) {
            start = 1;
            end = Math.min(windowSize, lastPage);
        }

        if (end > lastPage) {
            end = lastPage;
            start = Math.max(1, lastPage - windowSize + 1);
        }

        const pages = [];

        for (let p = start; p <= end; p++) {
            const isCurrent = p === currentPage;

            pages.push(
                <button
                    key={p}
                    
                    onClick={!isCurrent ? goTo(p) : undefined}
                    className={isCurrent ? styles.current : styles.button}
                >
                    {p}
                </button>
            );
        }

        return pages;
    }, [currentPage, lastPage, goTo]);

    const maxItems = Math.min(currentPage * limit, items);

    return (
        <div className={styles.wrapper}>
            <div className={styles.paginationDiv}>
                <div className={styles.paginationPager}>
                    <span>Zobrazit</span>

                    <NavSelect
                        name="limit_select"
                        data={limits}
                        value={limit}
                        onChange={changeLimit}
                        notNull
                        className={styles.paginator}
                        direction="up"
                    />

                    {/* Hide info text if only one page */}
                    {lastPage > 1 && (
                        <p className={styles.paginationPar}>
                            položky {(currentPage - 1) * limit + 1}-{maxItems} z {items}
                        </p>
                    )}
                </div>
            </div>

            {/* Hide entire navigation if only one page */}
            {lastPage > 1 && (
                <div className={styles.pagination}>
                    <button
                        disabled={currentPage === 1}
                        onClick={goTo(1)}
                        className={`${styles.button} ${styles.firstButton}`}
                    >
                        První
                    </button>

                    <button
                        disabled={currentPage === 1}
                        onClick={goTo(currentPage - 1)}
                        className={styles.button}
                    >
                        <ChevronLeftIcon
                            className={
                                currentPage === 1
                                    ? styles.arrowDisabled
                                    : styles.arrow
                            }
                        />
                    </button>

                    <div className={styles.pageNumbers}>
                        {pageWindow}
                    </div>

                    <button
                        disabled={currentPage === lastPage}
                        onClick={goTo(currentPage + 1)}
                        className={styles.button}
                    >
                        <ChevronRightIcon
                            className={
                                currentPage === lastPage
                                    ? styles.arrowDisabled
                                    : styles.arrow
                            }
                        />
                    </button>

                    <button
                        disabled={currentPage === lastPage}
                        onClick={goTo(lastPage)}
                        className={`${styles.button} ${styles.lastButton}`}
                    >
                        Poslední
                    </button>
                </div>
            )}
        </div>
    );
};